import { Injectable } from '@angular/core';
import writeExcelFile, { type Sheet } from 'write-excel-file/browser';

@Injectable({ providedIn: 'root' })
export class WorksheetService {
  async save(sheets: Sheet<Blob>[], fileName: string): Promise<void> {
    try {
      const data = await writeExcelFile(sheets).toBlob();

      const a = document.createElement('a');

      const url = URL.createObjectURL(data);
      a.href = url;
      a.download = `${fileName}.xlsx`;
      document.body.appendChild(a);

      a.click();

      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
    }
  }
}
